

















































import { defineComponent, ref, set } from "@vue/composition-api";
import { useBecomeCreatorState } from "@/hooks/useBecomeCreatorState";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import BaseStepper from "@/components/BaseStepper";
import PageTitle from "@/components/PageTitle/PageTitle";
import PersonalIdForm from "./components/PersonalIdForm.vue";
import PersonalInfoForm from "./components/PersonalInfoForm.vue";
import PublicInfo from "./components/PublicInfo.vue";
import UserAvatar from "./components/UserAvatar.vue";
import UserCategories from "./components/UserCategories.vue";
import UserContentType from "./components/UserContentType.vue";
import { StepData } from "../../types";
import PayeeInfoButton from "../PayeeInfoButton.vue";

export default defineComponent({
  name: "LimitedCreatorForm",
  components: { PageTitle, PayeeInfoButton, BaseButton, BaseStepper, BaseIcon },
  setup(props, { emit }) {
    const { lastStep, update: updateBecomeCreatorState, getData: getBecomeCreatorState } = useBecomeCreatorState();

    const submits = ref<Record<string, () => Promise<any>>>({});
    const valid = ref(false);
    const loading = ref(false);
    const sendingData = ref(false);

    const steps: StepData[] = [
      {
        name: "personalInfo",
        step: 1,
        component: PersonalInfoForm,
        required: true,
      },
      {
        name: "sensitiveAgreement",
        step: 2,
        component: PersonalIdForm,
        required: true,
      },
      {
        name: "publicInfo",
        step: 3,
        component: PublicInfo,
        required: true,
      },
      {
        name: "userCategories",
        step: 4,
        component: UserCategories,
        required: false,
      },
      {
        name: "userContentType",
        step: 5,
        component: UserContentType,
        required: false,
      },
      {
        name: "avatar",
        step: 6,
        component: UserAvatar,
        required: true,
      },
    ];

    const currentStep = ref<StepData>(steps[0]);

    const getStepTemplateName = (step: number) => "step-" + step;

    const handleTitleClick = async () => {
      if (currentStep.value.step === 1) {
        emit("showPromote", true);
      } else {
        emit("showPromote", false);
        currentStep.value = steps[currentStep.value.step - 2];
      }
    };

    const handleButtonClick = async (hasNext: boolean, step: number, skip?: boolean) => {
      const stepInProcess = steps[step - 1];
      if (!stepInProcess) return;

      if (!skip) {
        try {
          sendingData.value = true;
          await submits.value[stepInProcess.name]?.();
        } catch (e) {
          /* eslint-disable no-console */
          console.error(e);
          return;
        } finally {
          sendingData.value = false;
        }
      }

      if (hasNext) {
        loading.value = false;
        currentStep.value = steps[currentStep.value.step];
      } else {
        emit("startVerification");
      }
      !currentStep.value.doNotSaveStepProgress && updateBecomeCreatorState(hasNext ? currentStep.value.step : 0);
    };

    const setCb = (stepName: string, cb: Promise<any>) => {
      set(submits.value, stepName, cb);
    };

    const getData = async () => {
      try {
        loading.value = true;
        await getBecomeCreatorState();
        if (lastStep.value > 1) {
          currentStep.value = steps[lastStep.value - 1];
          emit("showPromote", false);
        }
      } finally {
        loading.value = false;
      }
    };

    getData();

    return {
      loading,
      valid,
      sendingData,
      currentStep,
      steps,
      getStepTemplateName,
      setCb,
      handleTitleClick,
      handleButtonClick,
    };
  },
});
